import { render } from "./protect.vue?vue&type=template&id=38714516"
import script from "./protect.vue?vue&type=script&lang=js"
export * from "./protect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/h5/Desktop/project/外包/huiduoduo/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__